import styled from 'styled-components';

export default styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  margin-top: -70px;
  position: fixed;
  z-index: 1001;

  @media (${p => p.theme.mq.desktop}) {
    margin-top: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/App/styles.js